import { createFileRoute } from '@tanstack/react-router';
import { CtaBand } from 'features/Landing/primitives';
import { Process } from 'features/Landing/sections/Process';
import { ServiceCards } from 'features/Landing/sections/ServiceCards';
import { type FC } from 'react';
import { breadcrumbJsonLd, buildHead } from 'seo/head';

const ServicesPage: FC = () => (
  <>
    <section className="bg-ink-900 pt-32 pb-16 sm:pt-40 sm:pb-20">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8">
        <p className="font-mono text-xs tracking-[0.25em] text-brand-400 uppercase">
          Services - Hamilton &amp; Waikato
        </p>
        <h1 className="font-display mt-4 max-w-3xl text-4xl leading-tight font-bold text-white sm:text-5xl">
          Concrete &amp; construction services
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-300 sm:text-lg">
          Foundations, driveways, patios, repairs, fencing and landscaping: every job priced
          fixed, poured to the drawings, and finished properly.
        </p>
      </div>
    </section>
    <ServiceCards sheet="DB-01 - Service index" />
    <Process />
    <CtaBand />
  </>
);

export const Route = createFileRoute('/_landing/services/')({
  head: () =>
    buildHead({
      title: 'Concrete & Construction Services | Dreams Built – Waikato',
      description:
        'Residential and commercial concrete foundations, driveways, patios, foundation repair, fencing and landscaping across Hamilton, Cambridge, Morrinsville, Te Awamutu and the Waikato.',
      path: '/services',
      jsonLd: [
        breadcrumbJsonLd([
          { name: 'Home', path: '/' },
          { name: 'Services', path: '/services' }
        ])
      ]
    }),
  component: ServicesPage
});
